// DS:
// DS1.11
import React from 'react';
import cn from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
import s from './Dots.scss';
var MINIMUM_PAGES = 2;
var Dots = function (_a) {
    var total = _a.total, current = _a.current, className = _a.className, onClick = _a.onClick;
    if (total < MINIMUM_PAGES) {
        return null;
    }
    var pages = Array.from(Array(total), function (_, i) { return i; });
    return (React.createElement("div", { className: cn(s['root'], className) }, pages.map(function (page) { return (React.createElement(PlainButtonOrLink, { key: "page-".concat(page), className: cn(s['dot'], page === current && s['current']), onClick: onClick && (function (e) { return onClick(page, e); }) })); })));
};
Dots.displayName = 'Dots';
export default Dots;
//# sourceMappingURL=Dots.js.map